import { render, staticRenderFns } from "./ICDRulesForm.vue?vue&type=template&id=3a422d48&scoped=true&"
import script from "./ICDRulesForm.vue?vue&type=script&lang=js&"
export * from "./ICDRulesForm.vue?vue&type=script&lang=js&"
import style0 from "./ICDRulesForm.vue?vue&type=style&index=0&id=3a422d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a422d48",
  null
  
)

export default component.exports